import firebase from 'firebase/app';
import 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyBKig9R5rkAei9BkKYifyc2eLUSJbHxJb4',
  authDomain: 'internal-d9b59.firebaseapp.com',
  projectId: 'internal-d9b59',
  storageBucket: 'internal-d9b59.firebasestorage.app',
  messagingSenderId: '921506096886',
  appId: '1:921506096886:web:e9799e872306b46ca2eed7',
  measurementId: 'G-Y65J7LPPG0',
};

let authApp;
const existing = firebase.apps.find(app => app.name === 'internal-auth');
if (existing) {
  authApp = existing;
} else {
  authApp = firebase.initializeApp(firebaseConfig, 'internal-auth');
}

export const auth = authApp.auth();
export default firebase;



// WEBPACK FOOTER //
// ./src/config/firebase.js